// Wrap case-insensitive matches of the query's whitespace tokens in <mark>
// within a plain-text string. Returns an array of strings and <mark> nodes,
// suitable for rendering directly in JSX.
export function highlightMatches(text, query) {
  const tokens = (query || '').trim().split(/\s+/).filter(Boolean)
  if (!tokens.length || !text) return [text]

  const escaped = tokens.map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
  const splitter = new RegExp(`(${escaped.join('|')})`, 'ig')
  const lower = new Set(tokens.map((t) => t.toLowerCase()))

  return text.split(splitter).map((part, i) =>
    lower.has(part.toLowerCase()) ? (
      <mark key={i} className="chat-mark">
        {part}
      </mark>
    ) : (
      part
    )
  )
}
